var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrivingLicenceCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 53,
    cy: 53,
    r: 53
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E4E4E4",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 28)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#C9C9C9",
    width: 71.68,
    height: 49.92,
    rx: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.84 0h33.92c1.06 0 1.92.86 1.92 1.92V48c0 1.06-.86 1.92-1.92 1.92H35.84V0z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.48 33.28)",
    fill: "#2F363B"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.96,
    width: 4.48,
    height: 8.64,
    rx: 1.92
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.48,
    height: 8.64,
    rx: 1.92
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.48 16.96)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F0F0F0",
    width: 21.12,
    height: 20.8,
    rx: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.56 0h8.64c1.06 0 1.92.86 1.92 1.92v16.96c0 1.06-.86 1.92-1.92 1.92h-8.64V0z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M16.96 21.12h12.48v5.44H16.96z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.32 25.28)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 29.44,
    height: 12.48,
    rx: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.72 0h12.8c1.06 0 1.92.86 1.92 1.92v8.64c0 1.06-.86 1.92-1.92 1.92h-12.8V0z",
    fill: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#545454",
    x: 42.24,
    y: 29.44,
    width: 21.12,
    height: 4.16,
    rx: 1.92
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#545454",
    x: 42.24,
    y: 37.76,
    width: 21.12,
    height: 4.16,
    rx: 1.92
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#545454",
    x: 42.24,
    y: 21.12,
    width: 4.16,
    height: 4.16,
    rx: 1.92
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#545454",
    x: 50.56,
    y: 21.12,
    width: 4.16,
    height: 4.16,
    rx: 1.92
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#545454",
    x: 58.88,
    y: 21.12,
    width: 4.16,
    height: 4.16,
    rx: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.68 8.8V.16H69.6c1.06 0 1.92.86 1.92 1.92V8.8H35.68z",
    fill: "#6F6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 8.8V.16H2.08C1.02.16.16 1.02.16 2.08V8.8H36z",
    fill: "#8D8D8D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivingLicenceCircle);
export default __webpack_public_path__ + "static/media/driving-licence-circle.534b7eb7a6a90fee964238dff12642c4.svg";
export { ForwardRef as ReactComponent };